import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 13,
	viewBox: "0 0 6 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.207552 9.27917L0.820052 8.66667L2.55547 10.4021L2.55547 0.9375L3.43047 0.9375L3.43047 10.4021L5.18047 8.65208L5.79297 9.26458L2.99297 12.0646L0.207552 9.27917Z",
		fill: "#1D1D1D"
	})
});
export default SvgSortArrowDown;
